import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Calendar, LogOut, Link as LinkIcon, Inbox, LayoutDashboard } from 'lucide-react';

export function Layout() {
    const { user, logout } = useAuth();
    const location = useLocation();

    const isActive = (path: string) => location.pathname.startsWith(path);

    return (
        <div className="min-h-screen">
            <header className="header">
                <div className="container header-content">
                    <Link to="/dashboard" className="header-logo">
                        <Calendar style={{ display: 'inline', marginRight: '8px' }} />
                        AAM <span>Let's Meet</span>
                    </Link>

                    {/* Navigation */}
                    <nav style={{ display: 'flex', gap: 'var(--space-1)', marginLeft: 'var(--space-6)' }}>
                        <Link
                            to="/dashboard"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 12px',
                                color: isActive('/dashboard') || isActive('/events') ? 'white' : 'rgba(255,255,255,0.7)',
                                textDecoration: 'none',
                                fontSize: 'var(--font-size-sm)',
                                borderRadius: 'var(--radius-sm)',
                                background: isActive('/dashboard') || isActive('/events') ? 'rgba(255,255,255,0.15)' : 'transparent'
                            }}
                        >
                            <LayoutDashboard size={16} />
                            Events
                        </Link>
                        <Link
                            to="/scheduling-links"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 12px',
                                color: isActive('/scheduling-links') ? 'white' : 'rgba(255,255,255,0.7)',
                                textDecoration: 'none',
                                fontSize: 'var(--font-size-sm)',
                                borderRadius: 'var(--radius-sm)',
                                background: isActive('/scheduling-links') ? 'rgba(255,255,255,0.15)' : 'transparent'
                            }}
                        >
                            <LinkIcon size={16} />
                            Links
                        </Link>
                        <Link
                            to="/proposals"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 12px',
                                color: isActive('/proposals') ? 'white' : 'rgba(255,255,255,0.7)',
                                textDecoration: 'none',
                                fontSize: 'var(--font-size-sm)',
                                borderRadius: 'var(--radius-sm)',
                                background: isActive('/proposals') ? 'rgba(255,255,255,0.15)' : 'transparent'
                            }}
                        >
                            <Inbox size={16} />
                            Proposals
                        </Link>
                    </nav>

                    <div className="header-user" style={{ marginLeft: 'auto' }}>
                        <span style={{ opacity: 0.8, fontSize: '0.875rem' }}>
                            {user?.name || user?.email}
                        </span>
                        <button
                            onClick={logout}
                            className="btn btn-ghost"
                            style={{ color: 'white', padding: '8px' }}
                            title="Sign out"
                        >
                            <LogOut size={18} />
                        </button>
                    </div>
                </div>
            </header>

            <main>
                <Outlet />
            </main>
        </div>
    );
}
